import { AddCircle, Edit } from '@mui/icons-material';
import { Button, CircularProgress, Grid, IconButton, Paper } from '@mui/material';
import MaterialReactTable from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { Link, useHistory } from 'react-router-dom';
import { paths } from 'routes';
import { UserActioner } from 'services/user';

function UserListComponent() {
  const [data, setData] = useState({ loading: true, docs: [] });
  const history = useHistory();

  useEffect(() => {
    if (data.loading) {
      UserActioner.getUserList().then(docs => {
        setData(f => ({ ...f, loading: false, docs }));
      });
    }
    return () => {};
  }, [data.loading]);

  const {
    messages: {
      scenes: {
        user: { list: intl },
      },
    },
  } = useIntl();
  const columnTitles = intl.columnTitles;

  const columns = useMemo(
    () => [
      {
        header: columnTitles.firstname,
        accessorKey: 'firstname',
      },
      {
        header: columnTitles.lastname,
        accessorKey: 'lastname',
      },
      {
        header: columnTitles.email,
        accessorKey: 'email',
      },
    ],
    [columnTitles.firstname, columnTitles.lastname, columnTitles.email],
  );

  if (data.loading) {
    return (
      <Paper className="padding-small">
        <Grid
          container
          spacing={0}
          direction="column"
          alignItems="center"
          justifyContent="center"
          className="height-circular"
        >
          <CircularProgress color="primary" />
        </Grid>
      </Paper>
    );
  }

  return (
    <MaterialReactTable
      columns={columns}
      data={data.docs}
      enableDensityToggle={false}
      enableColumnActions={false}
      muiTablePaginationProps={{
        rowsPerPageOptions: [10, 25, 50, 100, 150, { label: 'All', value: data?.docs.length ?? 0 }],
      }}
      positionActionsColumn="last"
      positionGlobalFilter="left" //show the global filter on the left side of the top toolbar
      initialState={{
        showGlobalFilter: true, //show the global filter by default
        density: 'compact',
        pagination: {
          pageSize: 25,
        },
      }}
      muiTableBodyCellProps={{
        //simple styling with the `sx` prop, works just like a style prop in this example
        sx: {
          fontWeight: 'normal',
          fontSize: '110%',
        },
      }}
      enableRowActions={true}
      renderRowActions={({ row }, index) => {
        return (
          <IconButton
            key={index}
            size="small"
            component={Link}
            to={paths.front.user.edit.replace(':id', row.original._id)}
          >
            <Edit />
          </IconButton>
        );
      }}
      enableToolbarInternalActions={true}
      renderTopToolbarCustomActions={() => {
        return (
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircle />}
            onClick={() => history.push(paths.front.user.create)}
          >
            {intl.button.add}
          </Button>
        );
      }}
    />
  );
}

const UserList = UserListComponent;

export { UserList };
